import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getEducationalDataById } from "services/_educational_resources";
import "react-quill/dist/quill.snow.css";

const Educational = () => {
  const { id } = useParams();
  const [educationData, setEducationData] = useState({});
  const navigate = useNavigate();
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  const initialData = useCallback(async () => {
    const data = await getEducationalDataById(id);
    if (data.isSuccess) {
      setEducationData(data.data);
    }
  }, [id]);

  useEffect(() => {
    initialData();
  }, [initialData]);

  const handleNavigate = () => {
    navigate("/educational-info");
  };

  const imgUrl = educationData?.image_url;

  return (
    <>
      <div style={{ backgroundColor: "#fff", paddingTop: "20px" }}>
        <section className="py-[30px] bg-white">
          <div className="container">
            <button
              onClick={handleNavigate}
              style={{
                padding: "15px 0 0 25px",
                fontSize: "18px",
                color: "#0D47A1",
              }}
            >
              <i
                className="fas fa-arrow-left"
                style={{ paddingRight: "10px" }}
              ></i>
              Educational-info / {educationData.title}
            </button>
            <div className="grid my_bio  my-[30px] gap-[50px] grid-cols-1 md:grid-cols-5">
              <div className="left_side md:col-span-2 flex justify-center items-center">
                {id ? (
                  <div className="mt-2 ">
                    <img
                      src={`${BACKEND_URL}${imgUrl}`}
                      alt="Preview"
                      style={{
                        width: "500px",
                        height: "500px",
                        objectFit: "contain",
                        borderRadius: "8px",
                      }}
                    />
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="right_side md:col-span-3">
                <h1
                  className="text-[36px] font-[700]"
                  style={{ textAlign: "right", paddingTop: "20px" }}
                >
                  {educationData.title}
                </h1>
                <p style={{ textAlign: "right", paddingBottom: "15px" }}>
                  {educationData.short_description}
                </p>
                <hr />
                <p
                  style={{ textAlign: "justify", paddingTop: "15px" }}
                  dangerouslySetInnerHTML={{ __html: educationData.content }}
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
export default Educational;
